import React, { useEffect, useState } from 'react';
import Input from '@amzn/meridian/input';

export interface NumberFieldProps {
  label: string;
  value: number;
  min: number;
  onCommit: (value: number) => void;
}

/**
 * A small numeric field that keeps its own raw text while the user types and
 * only commits (clamped to >= min, integer) on blur. This avoids the
 * "stuck at min" problem where coercing on every keystroke snaps an
 * intermediate empty/partial value back before the user finishes typing.
 */
const NumberField = ({ label, value, min, onCommit }: NumberFieldProps) => {
  const [draft, setDraft] = useState<string>(String(value));

  // Re-sync the draft when the committed value changes from outside (e.g.
  // inferred start/step on entering edit mode).
  useEffect(() => {
    setDraft(String(value));
  }, [value]);

  const commit = () => {
    const parsed = parseInt(draft, 10);
    const next = Number.isFinite(parsed) ? Math.max(min, Math.floor(parsed)) : min;
    onCommit(next);
    setDraft(String(next));
  };

  return (
    <div style={{ width: '90px' }}>
      <Input
        label={label}
        type="number"
        size="small"
        value={draft}
        onChange={(v: string) => setDraft(v)}
        onBlur={commit}
      />
    </div>
  );
};

export default NumberField;
